import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Row, Col, Label } from "reactstrap"
import { Editor } from "react-draft-wysiwyg"
import { EditorState, convertToRaw, convertFromRaw, ContentState, convertFromHTML } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import draftToHtml from 'draftjs-to-html';

import {postImages} from "helpers/backend_helper"

import DOMPurify from 'dompurify';

const CustomTextEditor = props => {

  const [editorState, setEditorState] = useState(
    () => EditorState.createEmpty(),
  );
  const  [convertedContent, setConvertedContent] = useState(null)

  const handleEditorChange = (state) => {
    setEditorState(state);
  }
  useEffect(() => {
    props.onTextEditorValueChange(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
  }, [editorState]);

  useEffect(() => {
    if(props.initialValue){
      const contentState = convertFromRaw(JSON.parse(props.initialValue));
      const editorState = EditorState.createWithContent(contentState)
      setEditorState(editorState)
    }
  }, [props.initialValue]);

  useEffect(() => {
    if(props.reset > 0){
      setEditorState(() => EditorState.createEmpty())
    }
  }, [props.reset])

  const createMarkup = (html) => {
    return  {
      __html: DOMPurify.sanitize(html)
    }
  }
  /*
  <div className="preview" dangerouslySetInnerHTML={createMarkup(convertedContent)}></div>
  */
  
  const uploadImageCallBack =  async (file) => {
    const data = new FormData();
    data.append('files', file);
    const response =  await postImages(data)
    //console.log('response:'+JSON.stringify(response))
    if(response.status == 'success'){
      let result =  { data: { link: response.url}}
      return result
    }
    else{
      return response
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
          <div className="mb-3">
            <Label for="productcode">
              Description
            </Label>
            <Editor
              editorState={editorState}
              onEditorStateChange={handleEditorChange}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              placeholder="Enter the product description..."
              toolbar={{
                history: { inDropdown: true },
                inline: { inDropdown: false },
                list: { inDropdown: true },
                textAlign: { inDropdown: true },
                image: {
                  urlEnabled: false,
                  uploadEnabled: true,
                  alignmentEnabled: true, // Whether to display the arrange button is equivalent to text-align
                  uploadCallback: uploadImageCallBack,
                  previewImage: true,
                  inputAccept: 'image/*',
                  alt: {present: false, mandatory: false}
                }
              }}
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

CustomTextEditor.propTypes = {
  onTextEditorValueChange: PropTypes.func,
  initialValue: PropTypes.any
}

export default CustomTextEditor
